module.exports = __webpack_public_path__ + "static/1-017-9e38aafa9316f258d5d604948edda6da.png";